export default __webpack_public_path__ + "static/image3-f63d7bc7256dbd54c37cf0037581c9c6.jpg";